module.exports = __webpack_public_path__ + "robotboy_1-c87f2599e6b5886cc7ae2c7875a1c5f1.png";